export function initResourceSwipers() {
  document.querySelectorAll(".js-resource-list-swiper").forEach((slider) => {
    new Swiper(slider, {
      slidesPerView: parseInt(slider.dataset.desktopSlides) || 1,
      spaceBetween: parseInt(slider.dataset.desktopGap) || 20,
      loop: slider.dataset.loopEnabled === "true",
      navigation: {
        nextEl: `#${slider.dataset.sectionId} .js-swiper-next`,
        prevEl: `#${slider.dataset.sectionId} .js-swiper-prev`,
      },
      breakpoints: {
        1024: {
          slidesPerView: parseInt(slider.dataset.desktopSlides) || 1,
          spaceBetween: parseInt(slider.dataset.desktopGap) || 20,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        575: {
          slidesPerView: 2.3,
          spaceBetween: 10,
        },
        0: {
          slidesPerView: 1.06,
          spaceBetween: 8,
        },
      },
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initResourceSwipers();
});
